'use client'

// src/context/root/context.tsx
import { createContext } from "react";
var context_default = createContext(null);

export {
  context_default
};
//# sourceMappingURL=chunk-2HWJLKTQ.mjs.map